import { getRuntimeFramework } from '../utils/getRuntimeFramework.mjs';
import { NextLink } from './NextLink.mjs';
import { PodoLink } from './PodoLink.mjs';

const Link = getRuntimeFramework() === "next" ? NextLink : PodoLink;

export { Link };
//# sourceMappingURL=index.mjs.map
